module.exports = __webpack_public_path__ + "static/media/linkedin.f6eaf68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/linkedin.jpg
// module id = 124
// module chunks = 1